<template>
  <section class="home_slider_wrapper">
    <div class="container">
      <div class="row slider_area">
        <template v-if="getBanners.length > 0">
          <slick
            ref="slick"
            :options="slickOptions"
          >
            <div
              v-for="banner in getBanners"
              :key="banner.banner_id"
              class="image_block"
            >

              <div
                class="img-fluid slider_size"
                :style="{backgroundImage: `url('${banner.banner_image}')`}"
              ></div>
            </div>
          </slick>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
import Slick from 'vue-slick'
import { mapActions, mapGetters } from 'vuex'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.scss'
export default {
  name: 'Carousel',
  components: { Slick },
  data: function () {
    return {
      slickOptions: {
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        autoplay: true,
        cssEase: 'linear'
      }
    }
  },
  computed: {
    ...mapGetters('pages/home', [
      'getBanners'
    ])
  },
  async created () {
    await this.getHomeBannerData()
  },
  methods: {
    ...mapActions('pages/home', [
      'getHomeBannerData'
    ])
  }
}
</script>
